import axios from 'axios';
import { apiClient } from './client';
import type { BulletinAttachmentPayload } from '../constants/bulletin';

type PresignResponse = {
  upload_url: string;
  method: string;
  headers: Record<string, string>;
  s3_key: string;
  content_type: string;
};

/**
 * 掲示板用: プリサイン取得後に S3 へ PUT し、DB 保存用メタを返す
 */
export async function presignAndUploadBulletinFile(file: File): Promise<BulletinAttachmentPayload> {
  const contentType = (file.type || 'application/octet-stream').trim().toLowerCase();
  const presignRes = await apiClient.post<PresignResponse>('/api/bulletin/attachments/presign', {
    content_type: contentType,
    original_filename: file.name,
  });
  const { upload_url, headers, s3_key } = presignRes.data;
  const putRes = await fetch(upload_url, {
    method: 'PUT',
    body: file,
    headers,
  });
  if (!putRes.ok) {
    throw new Error('upload_failed');
  }
  return {
    s3_key,
    original_filename: file.name,
    content_type: presignRes.data.content_type || contentType,
    byte_size: file.size,
  };
}

export function isBulletinUploadConfiguredError(e: unknown): boolean {
  return axios.isAxiosError(e) && e.response?.status === 503;
}
